import uniqId from "./uniqId";

export default class CreateColumn {
    constructor({ size, name = "Column" }) {
        return {
            name,
            style: {},
            content: [],
            id: uniqId(),
            _elType: "COLUMN",
            type: "column",
            component_path: "column",
            attr: {
                __class__columnSize: size
            }
        };
    }
}
